module.exports = __webpack_public_path__ + "static/media/12UNCTAD7.dae470db.jpg";